import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';

import background from 'assets/background.jpg';
import { AppRoutePath } from 'router/Routes';

const useStyles = makeStyles(() => ({
	dashletLink: {
		textDecoration: 'none',
	},
	dashletsContainer: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		width: '100%',
		justifyContent: 'center',
		padding: '109px',
		backgroundImage: `url(${background})`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
	},
	dashlet: {
		height: '132px',
		margin: '8px',
		padding: '16px 24px',
		width: '180px',
		color: '#ffffff',
	},
	firstDashlet: {
		backgroundColor: '#fcb729',
	},
	secondDashlet: {
		backgroundColor: '#7fb337',
	},
	thirdDashlet: {
		backgroundColor: '#2790d8',
	},
}));

const Dashlets: FC = () => {
	const classes = useStyles();

	const { t } = useTranslation('dashlets');

	return (
		<div className={classes.dashletsContainer}>
			<Link className={classes.dashletLink} to={AppRoutePath.SEARCH}>
				<div className={clsx(classes.dashlet, classes.firstDashlet)}>
					<Typography variant="h5">{t('search.title')}</Typography>
					<Typography variant="body1">{t('search.text')}</Typography>
				</div>
			</Link>
			<Link className={classes.dashletLink} to={AppRoutePath.HELP}>
				<div className={clsx(classes.dashlet, classes.secondDashlet)}>
					<Typography variant="h5">{t('help.title')}</Typography>
					<Typography variant="body1">{t('help.text')}</Typography>
				</div>
			</Link>
			<Link className={classes.dashletLink} to={AppRoutePath.CONTACT}>
				<div className={clsx(classes.dashlet, classes.thirdDashlet)}>
					<Typography variant="h5">{t('contact.title')}</Typography>
					<Typography variant="body1">{t('contact.text')}</Typography>
				</div>
			</Link>
		</div>
	);
};

export default Dashlets;
